module.exports = __webpack_public_path__ + "static/media/active_user.4415fe5c.svg";